<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="levelOfServiceLabs || []"
      calculate-widths
      show-expand
      item-key="name"
    >
      <template v-slot:top>
        <div class="d-flex">
          <v-btn
            class="ml-auto"
            color="secondary"
            @click="exportData"
          >
            {{ $t('export') }}
          </v-btn>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td
          class="pa-2"
          :colspan="headers.length"
        >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ $t('Laboratory') }}
                  </th>
                  <th class="text-left">
                    {{ $t('Manager') }}
                  </th>
                  <th class="text-left">
                    {{ $t('Address') }}
                  </th>
                  <th class="text-left">
                    {{ $t('Telephone') }}
                  </th>

                  <!--                  <th class="text-left">-->
                  <!--                    Parent Laboratory-->
                  <!--                  </th>-->
                  <!--                  <th class="text-left">-->
                  <!--                    Child Laboratories-->
                  <!--                  </th>-->
                  <!--                  <th class="text-left">-->
                  <!--                    Level Of Services-->
                  <!--                  </th>-->
                  <th class="text-left" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="lab in item.labs"
                  :key="lab.id + item.name"
                >
                  <td>{{ lab.name }}</td>

                  <td>
                    <span v-if="lab.manager">
                      {{ lab.manager.firstName }} {{ lab.manager.lastName }}
                    </span>
                  </td>
                  <td>{{ lab.address }}</td>
                  <td>{{ lab.telephone }}</td>
                  <!--                  <td>-->
                  <!--                    <template v-if="lab.parentLaboratory">-->
                  <!--                      {{ lab.parentLaboratory.name }}-->
                  <!--                    </template>-->
                  <!--                    <template v-else>-->
                  <!--                      - -->
                  <!--                    </template>-->
                  <!--                  </td>-->
                  <!--                  <td>-->
                  <!--                    <template v-if="lab.childLaboratories.length">-->
                  <!--                      <span-->
                  <!--                        v-for="(childLab, index) in lab.childLaboratories"-->
                  <!--                        :key="childLab.id"-->
                  <!--                      >-->
                  <!--                        <template v-if="index > 0">, </template>-->
                  <!--                        {{ childLab.name }}-->
                  <!--                      </span>-->
                  <!--                    </template>-->
                  <!--                    <template v-else>-->
                  <!--                      - -->
                  <!--                    </template>-->
                  <!--                  </td>-->
                  <!--                  <td>-->
                  <!--                    <v-chip-->
                  <!--                      v-for="service in levelOfServicesForDataTable(lab)"-->
                  <!--                      :key="service"-->
                  <!--                      class="mr-1 my-1"-->
                  <!--                    >-->
                  <!--                      {{ service }}-->
                  <!--                    </v-chip>-->
                  <!--                  </td>-->
                  <td>
                    <v-btn
                      icon
                      :to="{name: 'LaboratoryView', params: {laboratoryId: lab.id}}"
                      target="_blank"
                    >
                      <v-icon
                        small
                      >
                        mdi-open-in-new
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>

      <!--      @click:row="onClickOnLaboratory"-->
      <!--        <template v-for="lang in languages">-->
      <!--        </template>-->
    </v-data-table>
  </div>
</template>

<script>

    import {
        export_json_to_excel_custom
    } from '@/vendor/Export2Excel'


    export default {
        name: "LevelOfServiceLabs",

        props: {
            laboratories: {
                type: Array,
                required: true
            }
        },

        computed: {
            headers() {
                return [
                    {
                        text: this.$t('Name'),
                        value: 'name',
                        align: 'start',
                        sortable: false,
                    },
                    {
                        text: this.$t('Laboratories'),
                        value: 'labs.length',
                        align: 'start',
                        sortable: false,
                    },
                    {
                        text: '',
                        value: 'data-table-expand'
                    },
                ]
            },

            levelOfServiceLabs() {
                let services = {};
                this.laboratories.forEach(lab => {
                    let ls = lab.levelOfServices.split(', ');
                    for (let l of ls) {
                        if (l) {
                            if (!services[l]) {
                                services[l] = {
                                    name: l
                                };
                            }
                            if (!services[l].labs) {
                                services[l].labs = []
                            }

                            services[l].labs.push(lab)
                        }
                    }
                });

                return Object.values(services)
            }
        },

        methods: {
            levelOfServicesForDataTable(lab) {
                return lab.levelOfServices ? lab.levelOfServices.split(', ') : []
            },

            exportData() {
                // import('@/vendor/Export2Excel').then(excel => {
                let multiData = [];

                {
                    const tHeader = [
                        'Name', 'Laboratories'
                    ];


                    const filterVal = [
                        'name', 'labs'
                    ];

                    const deepValues = {
                        labs(item) {
                            return item?.labs?.length || ''
                        },
                    };

                    const data = this.levelOfServiceLabs.map(v => {
                        let filteredData = filterVal.map(j => {
                            if (v[j]) {
                                if (j in deepValues) {
                                    return deepValues[j](v)
                                } else {
                                    return v[j].toString()
                                }
                            }

                            return ''
                        });

                        return filteredData;
                    }).filter(e => e);

                    multiData.push({name: 'Statistics', header: tHeader, data})
                }
                {
                    const tHeader = [
                        '#', 'Id', 'Name', 'Address', 'Manager', 'Telephone'
                    ];


                    const filterVal = [
                        '#', 'id', 'name', 'address', 'manager', 'telephone'
                    ];

                    const deepValues = {
                        manager(item) {
                            return item?.manager?.firstName + '' + item?.manager?.lastName || ''
                        },
                    };

                    for(let s of this.levelOfServiceLabs) {
                        const data = s.labs.map((v, index) => {
                            return filterVal.map(j => {
                                if(j === '#') return index + 1;
                                if (v[j]) {
                                    if (j in deepValues) {
                                        return deepValues[j](v)
                                    } else {
                                        return v[j].toString()
                                    }
                                }

                                return ''
                            });
                        }).filter(e => e);

                        multiData.push({name: s.name, header: tHeader, data})

                    }
                }

                export_json_to_excel_custom({
                    multiData,
                    filename: 'methodologies-laboratories',
                    autoWidth: true,
                    // bookType: 'csv'
                })

                // export_json_to_excel({
                //     multiHeader: [['asd', '123'], ['456', '789']],
                //     header: tHeader, //Header Required
                //     data, //Specific data Required
                //     filename: 'methodologies-laboratories', //Optional
                //     autoWidth: true, //Optional
                //     bookType: 'csv' //Optional
                // })
                // })
            },

        }
    }
</script>

<style scoped>

</style>
